// extracted by mini-css-extract-plugin
export default {"thankYouWrapper":"thank-you_thankYouWrapper__oWHXL","thankYouWrapper__content":"thank-you_thankYouWrapper__content__EHesj"};